import {
    Dialog,
    DialogContent, 
    DialogHeader,
    DialogTitle,
} from '@/components/ui/dialog'   

interface AddDialogProps {
    isOpen: boolean
    onClose: () => void
    src: string
}
 

const ViewImageDialog = ({ isOpen, onClose, src }: AddDialogProps) => {    

    return (
        <Dialog open={isOpen} onOpenChange={onClose}>
            <DialogContent className='max-w-[600px] max-h-[90%] justify-center  overflow-auto'  aria-describedby={undefined}>
                <DialogHeader className='px-2'> 
                    <DialogTitle></DialogTitle>
                </DialogHeader> 
                <img src={src} alt="Imagem do produto" /> 
            </DialogContent>
        </Dialog>
    )
}

export default ViewImageDialog
